import { injectReducer } from '@app/store';
import { injectSaga } from '@app/store/rootSaga';
import { useEffect } from 'react';
import defectsReducer from '../store';
import defectsSagaWatcher from '../store/sagas';

export const useDefectsChunk = () => {
    useEffect(() => {
        injectReducer('defects', defectsReducer);
        injectSaga('defects', defectsSagaWatcher);
    }, []);
};
